import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

export interface GroupedLevelChangeItem {
  sk_user: string;
  oldLevel: string;
  newLevel: string;
  label: string;
}

export interface ActionModalData {
  news: string;
  credibility: number;
  credibility_delta: number;
  is_adoption_promoted: boolean;
  adoption_stage: string;
  // Objeto dinámico: keys = niveles (p.ej. Awareness, Interest, etc.)
  groupedLevelChanges?: Record<string, GroupedLevelChangeItem[]>;
}

@Component({
  selector: 'app-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss'],
  standalone: true,
  imports: [MatDialogContent, MatDialogActions, MatButtonModule, CommonModule],
})
export class ActionModalComponent implements OnInit {
  levelChangeKeyPairs: string[][] = [];
  allExpanded = false;
  hasOverflow = false; // true si alguna lista tiene > 2
  splits: Record<
    string,
    { left: GroupedLevelChangeItem[]; right: GroupedLevelChangeItem[] }
  > = {};

  constructor(
    public dialogRef: MatDialogRef<ActionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionModalData
  ) {}

  ngOnInit(): void {
    if (this.data.groupedLevelChanges) {
      const keys = Object.keys(this.data.groupedLevelChanges);
      // Mantener orden estable; si se quiere un orden específico se puede ordenar aquí.
      for (let i = 0; i < keys.length; i += 2) {
        this.levelChangeKeyPairs.push(keys.slice(i, i + 2));
      }
      // Detectar si hay alguna lista que requiera show more
      this.hasOverflow = keys.some(
        (k) => (this.data.groupedLevelChanges?.[k]?.length || 0) > 2
      );

      // Pre-calcular splits para columnas cuando haya más de 2
      keys.forEach((k) => {
        const arr = this.data.groupedLevelChanges![k] || [];
        if (arr.length > 2) {
          const mid = Math.ceil(arr.length / 2);
          this.splits[k] = {
            left: arr.slice(0, mid),
            right: arr.slice(mid),
          };
        }
      });
    }
  }

  toggleAll(): void {
    this.allExpanded = !this.allExpanded;
  }

  onContinue(): void {
    this.dialogRef.close(true);
  }
}
